<template>
  <v-sheet class="mx-auto search-basic-form" max-width="1180px">
    <v-form @submit.prevent="search" ref="form">
      <div class="grid-list-1">
        <TerrainCategorySelect hide-details />
        <CitiesSelect hide-details />
        <DistrictsSelect hide-details />
        <CondominiumField hide-details />
        <ReferenceField hide-details />
      </div>
      <div class="align-center mt-5 grid-list-2">
        <PriceRangeSlide />
        <TotalAreaRange />

        <ButtonWidget type="submit" height="40" block>
          Buscar
          <v-icon right>fa-search</v-icon>
        </ButtonWidget>
      </div>
    </v-form>
  </v-sheet>
</template>

<script>
import TerrainCategorySelect from "./fields/TerrainCategorySelect.vue";
import DistrictsSelect from "./fields/DistrictsSelect.vue";
import CitiesSelect from "./fields/CitiesSelect.vue";
import CondominiumField from "./fields/CondominiumField.vue";
import ReferenceField from "./fields/ReferenceField.vue";
import PriceRangeSlide from "./fields/PriceRangeSlide.vue";
import TotalAreaRange from "./fields/TotalAreaRange.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

export default {
  methods: {
    search() {
      const form = this.$refs.form;
      const formData = new FormData(form.$el);
      var path = "/terrenos";

      const parameters = [];
      const price = [];
      const totalArea = [];

      for (var pair of formData.entries()) {
        if (["min-price", "max-price"].includes(pair[0])) price.push(pair[1]);
        else if (["total-area-min", "total-area-max"].includes(pair[0]))
          totalArea.push(pair[1]);
        else if (
          ![
            "min-price",
            "max-price",
            "total-area-min",
            "total-area-max",
          ].includes(pair[0]) &&
          pair[1]
        )
          parameters.push(
            encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1])
          );
      }

      if (
        price.length == 2 &&
        (Number(price[0]) !== 0 || Number(price[1]) !== 20000000)
      )
        parameters.push(
          encodeURIComponent("preco") +
            "=" +
            encodeURIComponent(price.join(","))
        );

      if (totalArea.length == 2)
        parameters.push(
          encodeURIComponent("area-total") +
            "=" +
            encodeURIComponent(totalArea.join(","))
        );

      if (parameters.length) {
        if (parameters.length) path += "?" + parameters.join("&");

        this.$router.push({ path });

        this.$emit("search-submit");
      }
    },
  },
  components: {
    CitiesSelect,
    TerrainCategorySelect,
    DistrictsSelect,
    CondominiumField,
    ReferenceField,
    PriceRangeSlide,
    TotalAreaRange,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.search-basic-form::v-deep {
  .grid-list-1,
  .grid-list-2,
  .grid-list-3,
  .grid-list-4 {
    display: grid;
    gap: 15px;

    @media screen and (max-width: 959.9px) {
      gap: 12px;
    }
  }

  .grid-list-1 {
    grid-template-columns:
      calc(33.33% - 133px) calc(33.33% - 133px) calc(33.33% - 133px)
      170px
      170px;

    @media screen and (max-width: 959.9px) {
      grid-template-columns: repeat(2, calc(50% - 6px));
    }

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr;
    }
  }

  .grid-list-2 {
    grid-template-columns: calc(50% - 100px) calc(50% - 100px) auto;

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr;
    }
  }

  .v-text-field--outlined {
    fieldset {
      border-color: rgba(204, 190, 192, 0.8);
    }

    input {
      &::placeholder {
        color: var(--v-primary-lighten1);
      }
    }
  }
}
</style>
